var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.widgets.length
    ? _c(
        "GridLayout",
        {
          ref: "grid",
          staticClass: "dashboards-viewer",
          style: _vm.adjustMargins,
          attrs: {
            layout: _vm.widgets,
            "col-num": _vm.columns,
            "row-height": _vm.itemHeight,
            margin: _vm.margin,
            "is-draggable": _vm.isEditionMode,
            "is-resizable": _vm.isEditionMode,
            "auto-size": true,
            "use-css-transforms": true,
            "prevent-collision": false
          },
          on: {
            "update:layout": function($event) {
              _vm.widgets = $event
            },
            "layout-updated": _vm.handleLayoutUpdate,
            "layout-ready": _vm.handleLayoutReady
          }
        },
        _vm._l(_vm.widgets, function(widget) {
          return _c(
            "Widget",
            _vm._b(
              {
                key: widget.i,
                ref: "widget",
                refInFor: true,
                attrs: { "edition-mode": _vm.isEditionMode },
                on: {
                  change: _vm.handleWidgetChange,
                  delete: _vm.handleWidgetDelete
                }
              },
              "Widget",
              Object.assign({}, widget, { widgetsData: _vm.widgetsData }),
              false
            )
          )
        }),
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }